import { useEffect, useState } from 'react'
import './popup-top.scss'
// redux
import useUIActions from '../../../hooks/useUIActions'
// components
import Portal from '../portal/portal'
// icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons'
type PopupTopType = {
	isHTML?: boolean
	header?: boolean
	type: 'success' | 'error'
	label: string
	time?: number
	onHide?: () => void
}

const PopupTop = (props: PopupTopType) => {
	const { header = true, isHTML = false, type, label, time = 5000, onHide = () => {} } = props

	// hooks
	const { handleHidePopuptop } = useUIActions()

	const classes = (header ? 'header ' : '') + type

	const [active, setActive] = useState(true)

	useEffect(() => {
		const handleClose = setTimeout(() => {
			setActive(false)
			setTimeout(() => {
				onHide?.()
				handleHidePopuptop()
			}, 800)
		}, time)

		return () => clearTimeout(handleClose)
	}, [])

	return (
		<Portal id='pop-up'>
			<div className={`a-popup-top ${classes} ${active && 'active'}`}>
				<span className={`a-popup-top__icon-container ${type}`}>
					{type === 'success' ? (
						<FontAwesomeIcon icon={faCheck} />
					) : (
						<FontAwesomeIcon icon={faTimes} />
					)}
				</span>
				<div className='a-popup-top__label-container'>
					{isHTML ? <div dangerouslySetInnerHTML={{ __html: label }} /> : label}
				</div>
			</div>
		</Portal>
	)
}

export default PopupTop
